export default {
	jlDomain: '//jianli.m.58.com',
	_fromurl: encodeURIComponent(document.location.href),

	nameReg: /^[\u4e00-\u9fa5]{2,4}$/, // 姓名正则
	mobileReg: /^(0|86|17951)?(13[0-9]|14[0-9]|15[0-9]|16[6]|17[0-9]|18[0-9]|19[0-9])[0-9]{8}$/, // 手机号码正则
	schoolReg: /^[\u4e00-\u9fa5]{4,20}$/, // 学校名称正则
	majorReg: /^[\u4e00-\u9fa5]{2,20}$/, // 专业名称正则
	// 出生年份列表
	birthdayList: (function () {
		let birthdayYearList = [];
		let date = new Date(),
			currYear = date.getFullYear(),
			start = currYear - 60, // 最大年龄年份
			end = currYear - 16; // 最小年龄年份

		for (let i = start; i <= end; i++) {
			birthdayYearList.push(i + '年');
		}
		return birthdayYearList;
	})(),
	// 教育经历列表(对应的id从1开始)
	educationList: [
		'高中以下', // 1
		'高中', // 2
		'中专/技校', // 3
		'大专', // 4
		'本科', // 5
		'硕士', // 6
		'博士', // 7
		'MBA/EMBA' // 8
	],
	// 工作经验列表
	experienceList: [
		'无经验',
		'应届生',
		'1年以下',
		'1-3年',
		'3-5年',
		'5-10年',
		'10年以上'
	],
	experienceArray: [0, 5, 6, 1, 2, 3, 4], // 工作经验列表对应的value

	// 期望薪资列表
	salaryList: [
		'面议',
		'1000元以下',
		'1000-2000元',
		'2000-3000元',
		'3000-5000元',
		'5000-8000元',
		'8000-12000元',
		'12000-25000元',
		'25000元以上'
	],

	// 毕业年份列表
	eduYearList: (function () {
		let graduateYearList = [];
		let currYear = new Date().getFullYear() + 5; //应届生毕业时间推迟5年
		for (let i = currYear - 60; i <= currYear; i++) {
			graduateYearList.push(i + '年');
		}
		return graduateYearList;
	})(),

	// 毕业月份列表
	eduMonthList: [
		'01月',
		'02月',
		'03月',
		'04月',
		'05月',
		'06月',
		'07月',
		'08月',
		'09月',
		'10月',
		'11月',
		'12月'
	],

	// companyNameReg: /^[\u4e00-\u9fa5a-zA-Z0-9()（）\/\.&\s]{1,30}$/, // 公司名称/学校名称/专业名称正则
	// positionNameReg: /^[\u4e00-\u9fa5a-zA-Z0-9\/]{2,12}$/, // 职位名称正则
	emailReg: /\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w{2,}/, // 验证是否包含邮箱
	qqReg: /([0-9０１２３４５６７８９零一二三四五六七八九壹贰叁肆伍陆柒捌玖]{5})/ // 验证是否包含qq号
	// contactReg: /(([qｑQＱ]+)(.?|.{1,5})(([0-9]|[０-９]|[零一二三四五六七八九]|[①-⑨]|[㈠-㈨])[-_@\~\#\$\%\^\&\*]*){5,13})|((([0-9]|[０-９]|[零一二三四五六七八九]|[①-⑨]|[㈠-㈨])[-_@\~\#\$\%\^\&\*]*){5,13}(.?|.{1,5})([qｑQＱ]+))/ // qq电话等联系方式
};



// WEBPACK FOOTER //
// ./src/module/basic/util/config.js